import script from "./LoginRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginRegister.vue?vue&type=script&setup=true&lang=js"

import "./LoginRegister.vue?vue&type=style&index=0&id=5feed672&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5feed672"]])

export default __exports__